import React from 'react';
import x from './images/x.svg';

const Popup = (props) => {
    return (
        <div className={`popup-wrapper ${props.isShow ? 'show' : ''}`} onClick={handlePopupClick}>
            <div className='popup'>
                <div className='popup-header'>
                    <div className='close-btn' onClick={() => props.onClose()} style={{backgroundImage:x.bg()}}></div>
                </div>
                <div className='popup-content'>
                    {props.children}
                    {props.footerLink && (
                        <div className='popup-link-wrapper'>
                            <a className='popup-link' href='javascript:void(0)' onClick={props.footerLink.onLinkClick}>{props.footerLink.text}</a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    function handlePopupClick(e) {
        //console.info('e.target.classList', e.target.classList);
        if (e.target.classList.contains('popup-wrapper')) {
            props.onClose();
        }
    }

};

export default Popup;